import { render } from "./EvidenceList.vue?vue&type=template&id=04764820&scoped=true&ts=true"
import script from "./EvidenceList.vue?vue&type=script&lang=ts"
export * from "./EvidenceList.vue?vue&type=script&lang=ts"

import "./EvidenceList.vue?vue&type=style&index=0&id=04764820&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04764820"]])

export default __exports__